<template>
  <van-overlay show @click="$emit('close')" z-index="1000">
    <div class="text-right" :style="style">
      <img src="~@/assets/img/share.png" alt="" />
    </div>
  </van-overlay>
</template>

<script>
export default {
  name: 'WeixinShareTip',
  data() {
    return {
      miniprogram: false
    }
  },
  computed: {
    style() {
      return {
        'padding-right': this.miniprogram ? '13vw' : '3vw'
      }
    }
  },
  created() {
    this.$answerUtil.getEnv().then(res => {
      this.miniprogram = res.miniprogram
    })
  }
}
</script>
